// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1XqlE","image":"Header_image__5RwdQ","name":"Header_name__L3uvP","info":"Header_info__1B5f9","infoRow":"Header_infoRow__2Elxo"};